const today = new Date();

export const followUpInfo = {
  followUpDate: "",
  followUp: "",
  followUpStatus: "",
  videoCall: false,
  followupTaken: false,
  createdAt: new Date().toISOString().split("T")[0],
  createdBy: "",
  followUpTakenDate: "",
};
export const LeadInfo = {
  first_name: "",
  last_name: "",
  interestedIn: [],
  full_name: "",
  services: "",
  planned_area: "",
  location_type: "",
  facilities: [],
  company_name: "",
  lead_genrated_from: "",
  lead_alloted_to: "",
  preferred_contact_method: "",
  phone_number: "",
  lead_status: "",
  email: "",
  gst_number: "",
  address: "",
  followUp: [],
  notes: "",
  callRecordingUpload: "",
};
export const userDetails = {
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  contactNumber: "",
  permanentAddress: "",
  residentialAddress: "",
  emergencyContactNumber: "",
  emergencyContactName: "",
  photograph: "",
  emergencyContactRelation: "",
};
export const EmployeeInfo = {
  firstName: "",
  lastName: "",
  emailId: "",
  dateOfBirth: "",
  photograph: "",
  contactNumber: "",
  permanantAddress: "",
  residentialAddress: "",
  aadharcardNumber: "",
  aadharcardPhotoFront: "",
  aadharcardPhotoBack: "",
  pancardNumber: "",
  pancardPhoto: "",
  emergencyContactNumber: "",
  emergencyContactName: "",
  emergencyContactRelation: "",
  previousOrganizationName: "",
  previousOrganizationLocation: "",
  totalYearsOfExperience: "",
  qualification: "",
  contractOfEmployment: "",
  roleInOrganisation: "",
  workingPlace:
    "319, City Avenue Pune Bangalore, Highway, Wakad, Pimpri-Chinchwad, Pune, Maharashtra 411057",
  packageJoinedAt: "",
  offerLetterAcceptance: "",
  joiningLetterScan: "",
  reportingTo: "",
  bankpassbookPhoto: "",
  residentialProofPhoto: "",
  mobileGivenByOrganisation: "",
  laptopGivenByOrganisation: "",
  simCardGivenByOrganisation: "",
  mobileId: "",
  laptopId: "",
  simCardNumber: "",
  hireViaAgencyOrDirect: "",
  agencyExpences_exlGST: "",
  salaryPerMonth: "",
  pfptDeduction: "",
  modeOfSalary: "",
  bankAccountNumber: "",
  dateOfJoining: "",
  position: "",
  assignBuddy: "",
  progress: [
    {
      task: "appointmentLetter",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "employeeAccount",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "trainingPrograme",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "softwareDemo",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "assignBuddy",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "emailAccount",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "emailBranding",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "introductionGuide",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "induction",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "attendanceSystem",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "watsappGroup",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "collectPhoto",
      completed: false,
      startDate: "",
      endDate: "",
    },
  ],
};
export const QuotationInfo = {
  quotationDate: today.toISOString().substr(0, 10),
  costMarkupPercent: "",
  overrideUnitCost: "",
  overrideCostByPercent: "",
  bay_size: "",
  span_size: "",
  quotationType: "",
  isroundTop: false,
  a_FramePercent: "",
  flatBedPercent: "",
  growBagPercent: "",
  genrated_by: "",
  dutchBucketPercent: "",
  farmType: "outdoor",
  businessName: "",
  contactPersonName: "",
  phoneNumber: "",
  whatsAppNumber: "",
  contactPersonEmail: "",
  gstNumber: "",
  address: "",
  currencyCode: "INR",
  maxDiscount: "",
  showProjectFinancials: true,
  finalQuotation: false,
  notes: "",
  addOnParticulars: "",
  addOnParticularsPrice: "",
  isGrowSlab: false,
  fullyAutomatedSystem: false,
  semiAutomatedSystem: false,
  termsAndConditions: "",
  dripSystem: false,
  foggerSystem: false,
  automation: false,
  weedMat: false,
  cropsupportSystem: false,
  aircirculationFan: false,
  mechanicalGearedVentOpening: false,
  growersCombo: false,
  retractableAluminumNet: false,
  // elect: false,
  // baseVarient: false,
  // midVarient: false,
  // topVarient: false,
  aircirculationFan: false,
  selectedSystem: "As Per Industry",
  infrastructure: [],
  asPerIndustry: [],
  kryzenPro: [],
  kryzenProMax: [],
};
export const qtnType = [
  "fanpad",
  "nvph",
  "nethouse",
  "fanpad with hydroponics",
  "nvph with hydroponics",
  "nethouse with hydroponics",
  "hydroponics only",
];
export const EmployeeLeavesInfo = {
  leaveDate: "",
  leaveType: "",
  leaveStatus: "pending",
  leaveStartDate: "",
  leaveEndDate: "",
  leaveReason: "",
  leaveReasonType: "",
  halfDayType: "",
  supportingDocument: "",
};

export const VendorInfo = {
  businessName: "",
  businessAddress: "",
  state: "",
  businessNature: "",
  generatedBy: "",
  notes: "",
  notHaveGST: false,
  legalConstitution: "",
  contactPersonName: "",
  contactPersonPhone: "",
  alternateContactPersonPhone: "",
  contactPersonEmail: "",
  gstNumber: "",
  panNumber: "",
  bankName: "",
  paymentTerm: "",
  bankAccountName: "",
  bankAccountNumber: "",
  bankIFSC: "",
  referredBy: "",
  acceptedPaymentMode: ["NEFT"],
  vendorStatus: "active",
  gstCertificate: "",
  vendorReg: "",
  vendorSign: "",
  vendorBankPassbook: "",
  vendorAgreement: "",
  customDeal: "",
  vendorDealsIn: [],
};
export const lineItemInfo = {
  particulars: "",
  itemUnit: "",
  totalWithoutGst: "",
  totalWithGst: "",
  itemQuantity: "",
  discount: "",
  itemPrice: "",
  gstRate: "",
  deliveryDate: today.toISOString().substr(0, 10),
  notes: "",
  id: "",
  hsn: "",
  sku: "",
  itemFrom: "inventory",
};

export const GrnlineItemInfo = {
  particulars: "",
  itemUnit: "",
  totalWithoutGst: "",
  totalWithGst: "",
  itemQuantity: "",
  discount: "",
  itemPrice: "",
  gstRate: "",
  deliveryDate: today.toISOString().substr(0, 10),
  notes: "",
  id: "",
  hsn: "",
  sku: "",
  itemFrom: "inventory",
};

export const GrnInfo = {
  project: "",
  vendor: "",
  poType: "Work order PO",
  poId: "",
  countryOfSupply: "india",
  vendorInvoiceNumber: "",
  paymentPriority: "",
  taxInvoice: "",
  performaInvoice: "",
  approveStatus: false,
  paymentAmount: "",
  paymentType: "",
  placeOfSupply: "",
  generatedBy: "",
  notes: "",
  pdfStatus: false,
  vendorPurchaseOrderDate: new Date().toISOString().split("T")[0],
  vendorPurchaseOrderFor: "",
  lineItems: [],
};

export const PurchaseOrderInfo = {
  project: "",
  vendor: "",
  poType: "Work order PO",
  countryOfSupply: "india",
  vendorInvoiceNumber: "",
  paymentPriority: "",
  taxInvoice: "",
  performaInvoice: "",
  approveStatus: false,
  paymentAmount: "",
  paymentType: "",
  placeOfSupply: "",
  generatedBy: "",
  notes: "",
  pdfStatus: false,
  vendorPurchaseOrderDate: new Date().toISOString().split("T")[0],
  vendorPurchaseOrderFor: "",
  lineItems: [],
};
export const ServiceOrderInfo = {
  project: "",
  vendor: "",
  poType: "Work order PO",
  countryOfSupply: "india",
  vendorInvoiceNumber: "",
  paymentPriority: "",
  taxInvoice: "",
  performaInvoice: "",
  approveStatus: false,
  paymentAmount: "",
  paymentType: "",
  placeOfSupply: "",
  generatedBy: "",
  notes: "",
  pdfStatus: false,
  vendorPurchaseOrderDate: new Date().toISOString().split("T")[0],
  vendorPurchaseOrderFor: "",
  lineItems: [],
};

export const serviceLineItemInfo = {
  particulars: "",
  itemUnit: "",
  totalWithoutGst: "",
  totalWithGst: "",
  itemQuantity: "",
  discount: "",
  itemPrice: "",
  gstRate: "",
  deliveryDate: today.toISOString().substr(0, 10),
  notes: "",
  id: "",
  hsn: "",
  sku: "",
  itemFrom: "inventory",
};
export const RFQINFOlineItemInfo = {
  particulars: "",
  itemUnit: "",
  itemQuantity: "",
  deliveryDate: today.toISOString().substr(0, 10),
  id: "",
  itemFrom: "inventory",
};

export const RFQINFO = {
  project: "",
  vendor: "",
  rfqType: "RFQ",
  countryOfSupply: "india",
  placeOfSupply: "",
  generatedBy: "",
  pdfStatus: false,
  vendorQuotationOrderDate: "",
  vendorQuotationOrderFor: "",
  lineItems: [],
};
export const DeliveryLineItemInfo = {
  type: "",
  particulars: "",
  id: "",
  hsn: "",
  itemUnit: "",
  itemQuantity: "",
  itemFrom: "inventory",
};
export const DeliveryChallanInfo = {
  project: "",
  pdfStatus: false,
  materilListNum: "",
  countryOfSupply: "india",
  placeOfSupply: "",
  lrNumber: "",
  ewayBillNumber: "",
  transportName: "",
  vehicleNumber: "",
  driverName: "",
  driverPhoneNumber: "",
  generatedBy: "",
  challanDate: new Date().toISOString().slice(0, 10),
  lineItems: [],
  driverDL: "",
  vehicleFront: "",
  vehicleBack: "",
  additionalPhotos: [],
  cusClientName: "",
};
export const ClientProjectInfo = {
  clientName: "",
  clientEmail: "",
  clientContactNumber: "",
  progressStatus: [],
  businessName: "",
  businessGstNumber: "",
  businessType: "",
  panNumber: "",
  aadharcardNumber: "",
  billingAddress: "",
  farmAddress: "",
  generatedBy: "",
  notes: "",
  farmPinCode: "",
  siteInspectionType: "In Person",
};
export const labourTrainingInfo = {
  startDate: "",
  labourName: "",
  clientProjectNumber: "",
  labourSchedule: [],
};
// export const ClientSiteInspenctionInfo = {
//   projectId: "",
//   inspectionDate: today.toISOString().substr(0, 10),
//   tentativeStartDate: "",
//   generatedBy: "",
//   siteAddress: "",
//   sitePinCode: "",
//   siteManagerName: "",
//   quotationNumber: "",
//   aifQuotationNumber: "",
//   siteManagerPhone: "",
//   numberOfStaff: "",
//   typeOfSite: "",
//   soilType: "",
//   totalAvailableAreaUnit: "",
//   totalAvailableAreaNumber: "",
//   landOwnership: "",
//   landLeveling: "",
//   naturalSlopeOfLand: "",
//   landHasTree: false,
//   landHasStones: false,
//   landHasPond: false,
//   landHasMudPatch: false,
//   landHasHillock: false,
//   landFencingType: "",
//   landFencingHeightInFeet: "",
//   whatsOnNorth: "",
//   whatsOnEast: "",
//   whatsOnSouth: "",
//   whatsOnWest: "",
//   obstaclesTowardsSky: false,
//   obstaclesTowardsSkyPhoto: "",
//   googleMapsLocationLink: "",
//   waterSourceType: "",
//   waterTankCapacityInLitre: "",
//   waterAvailabilityFrequency: "",
//   positionOfWaterTank: "",
//   waterTankLocationPhoto: "",
//   waterPhReading: "",
//   waterEcReading: "",
//   waterReportPhoto: "",
//   entryToFarmSite: "",
//   entryTofarmPhoto: "",
//   luxReading: "",
//   luxReadingPhoto: "",
//   luxDeffusionSheet: "",
//   luxDeffusionSheetPhoto: "",
//   luxWovenPoly: "",
//   luxWovenPolyPhoto: "",
//   luxUvOpen: "",
//   luxUvOpenPhoto: "",
//   temperatureReading: "",
//   temperatureReadingPhoto: "",
//   humidityReading: "",
//   humidityReadingPhoto: "",
//   climateHottestMonth: "",
//   climateColdestMonth: "",
//   northSouthMeasurmentInMeter: "",
//   northSouthMeasurmentPhoto: "",
//   eastWestMeasurmentInMeter: "",
//   eastWestMeasurmentPhoto: "",
//   layoutPhoto: "",
//   facilityToStoreItems: false,
//   facilityToStay: false,
//   facilityHasBathroom: false,
//   facilityHasDrinkingWater: false,
//   facilityHasKitchenSpace: false,
//   facilityHasFuelForCooking: false,
//   transportOption: "",
//   nearestTarRoad: "",
//   nearestMarket: "",
//   nearestMedicalFacility: "",
//   nearestStayFacility: "",
//   nearestBusStand: "",
//   nearestRailwayStation: "",
//   nearestAirport: "",
//   nearestTier1City: "",
//   nearestTier1CityDistance: "",
//   nearestTier2City: "",
//   nearestTier2CityDistance: "",
//   regulerModeOfTransportation: "",
//   vehicleAvilableForEmergency: "",
//   electricityConnectionAvailable: false,
//   electricityMeterType: "",
//   electricityMeterPhaseType: "",
//   electricityOutageFrequency: "",
//   electricityUnitPrice: "",
//   electricityPricingModel: "",
//   electricityUsage: "",
//   internetConnectivity: "",
//   descriptionVideo: "",
//   notes: "",
//   salesRelationshipManager: "",
//   lookingForGovernmentSupport: false,
//   projectOwnerGender: "",
//   location: "",
//   cast: "",
//   averageLabourSalary: 8000,
//   monthlyLeasedAmount: 0,
//   projectFundingPlan: "",
//   futureExpectationFromPlan: "",
//   experienceWithFarming: "",
//   currentProfession: "",
//   markSiteNotFeasible: false,
//   reasonOfNonFeasibility: "",
//   markWaterNotAvailable: false,
//   lookingForLoan: false,
//   loanBanks: "",
//   borrowFromBank: 0,
//   appliedForAIFDPR: false,
//   tenure: 7,
//   rateOfInt: 9,
//   fundingAmmountType: "postGST",
// };

export const ClientSiteInspenctionInfo = {
  name: "",
  dateOfBirth: "",
  highestQualification: "",
  currentProfession: "",
  experienceWithFarming: "",
  projectOwnerGender: "",
  cast: "",
  applicationType: "",
  siteAddress: "",
  siteAddressLine1: "",
  siteAddressLine2: "",
  sitePinCode: "",
  city: "",
  state: "",
  identitfyLocation: "",
  locationIdentification: "",
  latitudeAndLongitude: "",
  typeOfSite: "",
  tentativeStartDate: "",
  siteManagerAppointed: "",
  siteManagerName: "",
  siteManagerPhone: "",
  numberOfStaff: "",

  projectId: "",
  inspectionDate: today.toISOString().substr(0, 10),
  generatedBy: "",

  quotationNumber: "",
  aifQuotationNumber: "",
  soilType: "",
  totalAvailableAreaUnit: "",
  totalAvailableAreaNumber: "",
  landOwnership: "",
  landLeveling: "",
  naturalSlopeOfLand: "",
  landHasTree: false,
  landHasStones: false,
  landHasPond: false,
  landHasMudPatch: false,
  landHasHillock: false,
  landFencingType: "",
  landFencingHeightInFeet: "",
  landLeaseAmount: "",
  whatsOnNorth: "",
  whatsOnEast: "",
  whatsOnSouth: "",
  whatsOnWest: "",
  obstaclesTowardsSky: false,
  obstaclesTowardsSkyPhoto: "",
  googleMapsLocationLink: "",
  waterSourceType: "",
  waterTankCapacityInLitre: "",
  waterAvailabilityFrequency: "",
  positionOfWaterTank: "",
  waterTankLocationPhoto: "",
  waterPhReading: "",
  waterEcReading: "",
  waterReportPhoto: "",
  entryToFarmSite: "",
  entryTofarmPhoto: "",
  luxReading: "",
  luxReadingPhoto: "",
  luxDeffusionSheet: "",
  luxDeffusionSheetPhoto: "",
  luxWovenPoly: "",
  luxWovenPolyPhoto: "",
  luxUvOpen: "",
  luxUvOpenPhoto: "",
  temperatureReading: "",
  temperatureReadingPhoto: "",
  humidityReading: "",
  humidityReadingPhoto: "",
  climateHottestMonth: "",
  climateColdestMonth: "",
  northSouthMeasurmentInMeter: "",
  northSouthMeasurmentPhoto: "",
  eastWestMeasurmentInMeter: "",
  eastWestMeasurmentPhoto: "",
  layoutPhoto: "",
  costructionLayout: "",
  systemLayout: "",
  pSideView: "",
  pCenterView: "",
  pEndView: "",
  facilityToStoreItems: false,
  facilityToStay: false,
  facilityHasBathroom: false,
  facilityHasDrinkingWater: false,
  facilityHasKitchenSpace: false,
  facilityHasFuelForCooking: false,
  transportOption: "",
  nearestTarRoad: "",
  nearestMarket: "",
  nearestMedicalFacility: "",
  nearestStayFacility: "",
  nearestBusStand: "",
  nearestRailwayStation: "",
  nearestAirport: "",
  nearestTier1City: "",
  nearestTier1CityDistance: "",
  nearestTier2City: "",
  nearestTier2CityDistance: "",
  regulerModeOfTransportation: "",
  vehicleAvilableForEmergency: "",
  electricityConnectionAvailable: false,
  electricityMeterType: "",
  electricityMeterPhaseType: "",
  electricityOutageFrequency: "",
  electricityUnitPrice: "",
  electricityPricingModel: "",
  electricityUsage: "",
  internetConnectivity: "",
  descriptionVideo: "",
  notes: "",
  salesRelationshipManager: "",
  lookingForGovernmentSupport: false,
  location: "",
  averageLabourSalary: 8000,
  monthlyLeasedAmount: 0,
  projectFundingPlan: "",
  futureExpectationFromPlan: "",
  markSiteNotFeasible: false,
  reasonOfNonFeasibility: "",
  markWaterNotAvailable: false,
  lookingForLoan: false,
  loanBanks: "",
  borrowFromBank: 0,
  appliedForAIFDPR: false,
  tenure: 7,
  rateOfInt: 9,
  fundingAmmountType: "postGST",
  primaryLoanBank: "",
  primaryLoanIfsc: "",
  secondaryLoanBank: "",
  secondaryLoanIfsc: "",
  northSouthMeasurmentViedo: "",
  eastWestMeasurmentViedo: "",
};

export const ProjectTrackingInfo = {
  projectId: "",
  siteSelectionId: "",
  workOrderUpload: "",
  signQuotationUpload: "",
  taskList: [
    {
      taskName: "Work Order",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Ready For Dispatch",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Acomadation Arrangement",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Foundation Work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Optional Hydroponic Material Dispatch",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Hydroponic System Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "QA Of Project",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Return Tickets",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Project Handover",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
  ],
  // old one
  // taskList: [
  //   {
  //     taskName: "Project Started",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },

  //   {
  //     taskName: "Work Order",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "alpha.kryzen.com Demo",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "1st Batch Flow",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "CEA Manufacturing Started ",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "CEA material procured in factory",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "CEA Manufacturing Finished ",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "CEA Ready For Dispatch",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Land Level",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Labour Ticket ",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Labour Stay Arrangement",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Labour Food Arrangement",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Labour Arrived ",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Land Level Checking",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Civil Material For Foundation",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "CEA Foundation",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Fan Structure Civil Foundation",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Pad Structure Civil Foundation ",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "2nd Batch Flow",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "CEA Structure Fitting",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "CEA Hocky Installation",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "CEA Gutter Installation",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Fan Installation",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Cellulose Pad Installation",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Polyhouse Top Paper Fitting",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Polyhouse Shadenet",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Polyhouse Side Vent Paper Fitting",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Polyhouse Entry Cabin Structure",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Water Tank Digging Work",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Water Tank Civil Work",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Civil Material For A Frame",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "A Frame Foundation",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "A Frame Installation",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Weed Mat Installation",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "NFT Connector Plumbing work",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "NFT Pipe Installation",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "NFT to Resoirvoir Plumbing work ",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "NFT Waterflow Testing",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Growbag Resoirvoir Plumbing work",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Cocopeat Decompression",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Growbag Filling",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Grow Bag Dripline work",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Grow Bag 4Way Drip Dispenser Work",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Grow Bag Trellising work",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "QA of Project",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Project Handover",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Farm Labour training 7 Days Program",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Hydroponic SOP / Nutrient Chart",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },

  //   {
  //     taskName: "Hydroponic Starter Kit",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Farm Management Software Demo",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   {
  //     taskName: "Labour return Tickets",
  //     scheduleDate: "",
  //     completionDate: "",
  //     responsibleStaff: "",
  //     isLocked: false,
  //     isNotApplicable: false,
  //     isProjectFinal: false,
  //     isUpdated: false,
  //   },
  //   // {
  //   //   taskName: "Agronomy Support Start",
  //   //   scheduleDate: "",
  //   //   completionDate: "",
  //   //   responsibleStaff: "",
  //   //   isLocked: false,
  //   //   isNotApplicable: false,
  //   //   isProjectFinal: false,
  //   //   isUpdated: false,
  //   // },
  // ],
  notes: "",
};
export const ProjectTrackingInfoNVPH = {
  projectId: "",
  siteSelectionId: "",
  workOrderUpload: "",
  taskList: [
    {
      taskName: "Project Started",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Work Order",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "alpha.kryzen.com Demo",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "1st Batch Flow",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Manufacturing Started ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA material procured in factory",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Manufacturing Finished ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Ready For Dispatch",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Land Level",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Ticket ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Stay Arrangement",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Food Arrangement",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Arrived ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Land Level Checking",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Civil Material For Foundation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Foundation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "2nd Batch Flow",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Structure Fitting",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Hocky Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Gutter Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Polyhouse Top Paper Fitting",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Polyhouse Shadenet",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Polyhouse Side Vent Paper Fitting",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Polyhouse Entry Cabin Structure",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Water Tank Digging Work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Water Tank Civil Work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "A Frame Foundation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "A Frame Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Weed Mat Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "NFT Waterflow Testing",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Growbag Resoirvoir Plumbing work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Cocopeat Decompression",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Growbag Filling",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Grow Bag Dripline work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Grow Bag 4Way Drip Dispenser Work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Grow Bag Trellising work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "QA of Project",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Project Handover",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Farm Labour training 7 Days Program",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Hydroponic SOP / Nutrient Chart",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },

    {
      taskName: "Hydroponic Starter Kit",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Farm Management Software Demo",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour return Tickets",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    // {
    //   taskName: "Agronomy Support Start",
    //   scheduleDate: "",
    //   completionDate: "",
    //   responsibleStaff: "",
    //   isLocked: false,
    //   isNotApplicable: false,
    //   isProjectFinal: false,
    //   isUpdated: false,
    // },
  ],
  notes: "",
};
export const ProjectTrackingInfoFanpad = {
  projectId: "",
  siteSelectionId: "",
  workOrderUpload: "",
  taskList: [
    {
      taskName: "Project Started",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },

    {
      taskName: "Work Order",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "alpha.kryzen.com Demo",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "1st Batch Flow",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Manufacturing Started ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA material procured in factory",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Manufacturing Finished ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Ready For Dispatch",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Land Level",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Ticket ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Stay Arrangement",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Food Arrangement",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Arrived ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Land Level Checking",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Civil Material For Foundation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Foundation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Fan Structure Civil Foundation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Pad Structure Civil Foundation ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "2nd Batch Flow",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Structure Fitting",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Hocky Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "CEA Gutter Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Fan Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Cellulose Pad Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Polyhouse Top Paper Fitting",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Polyhouse Shadenet",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Polyhouse Side Vent Paper Fitting",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Polyhouse Entry Cabin Structure",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Water Tank Digging Work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Water Tank Civil Work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Civil Material For A Frame",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "A Frame Foundation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "A Frame Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Weed Mat Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Growbag Resoirvoir Plumbing work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Cocopeat Decompression",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Growbag Filling",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Grow Bag Dripline work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Grow Bag 4Way Drip Dispenser Work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Grow Bag Trellising work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "QA of Project",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Project Handover",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Farm Labour training 7 Days Program",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Hydroponic SOP / Nutrient Chart",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },

    {
      taskName: "Hydroponic Starter Kit",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Farm Management Software Demo",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour return Tickets",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    // {
    //   taskName: "Agronomy Support Start",
    //   scheduleDate: "",
    //   completionDate: "",
    //   responsibleStaff: "",
    //   isLocked: false,
    //   isNotApplicable: false,
    //   isProjectFinal: false,
    //   isUpdated: false,
    // },
  ],
  notes: "",
};
export const ProjectTrackingInfoAframe = {
  projectId: "",
  siteSelectionId: "",
  workOrderUpload: "",
  taskList: [
    {
      taskName: "Project Started",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },

    {
      taskName: "Work Order",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "alpha.kryzen.com Demo",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "1st Batch Flow",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Land Level",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Ticket ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Stay Arrangement",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Food Arrangement",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour Arrived ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Land Level Checking",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Civil Material For Foundation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "2nd Batch Flow",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Polyhouse Shadenet",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Water Tank Digging Work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Water Tank Civil Work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "A Frame Foundation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "A Frame Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Weed Mat Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "NFT Connector Plumbing work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "NFT Pipe Installation",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "NFT to Resoirvoir Plumbing work ",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "NFT Waterflow Testing",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Growbag Resoirvoir Plumbing work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Cocopeat Decompression",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Growbag Filling",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Grow Bag Dripline work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Grow Bag 4Way Drip Dispenser Work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Grow Bag Trellising work",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "QA of Project",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Project Handover",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Farm Labour training 7 Days Program",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Hydroponic SOP / Nutrient Chart",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },

    {
      taskName: "Hydroponic Starter Kit",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Farm Management Software Demo",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    {
      taskName: "Labour return Tickets",
      scheduleDate: "",
      completionDate: "",
      responsibleStaff: "",
      isLocked: false,
      isNotApplicable: false,
      isProjectFinal: false,
      isUpdated: false,
    },
    // {
    //   taskName: "Agronomy Support Start",
    //   scheduleDate: "",
    //   completionDate: "",
    //   responsibleStaff: "",
    //   isLocked: false,
    //   isNotApplicable: false,
    //   isProjectFinal: false,
    //   isUpdated: false,
    // },
  ],
  notes: "",
};
export const ClientExpenseInfo = {
  projectSelection: "",
  siteSelection: "",
  vendor: "",
  expenseDate: "",
  expenseType: "",
  expenseFor: "",
  uploadBill: "",
  expenseAmount: "",
  gstAmount: 0,
  paidBy: "",
  paymentMode: "",
  notes: "",
};
export const ClientPaymentInfo = {
  projectSelection: "",
  siteSelection: "",
  paymentDate: "",
  paymentAmount: "",
  paymentGenratedBy: "",
  paymentMode: "",
  gstRate: 0,
  notes: "",
};
export const ClientProjectHandoverInfo = {
  projectId: "",
  handOverDate: new Date().toISOString().slice(0, 10),
  siteSelectionId: "",
  generatedBy: "",
  northSouthMeasurmentInMeter: "",
  northSouthMeasurmentPhoto: "",
  eastWestMeasurmentInMeter: "",
  eastWestMeasurmentPhoto: "",
  handOverCertificate: "",
  descriptionVideo: "",
  notes: "",
  overheadTankPhoto: "",
  aFramePhoto: "",
  netCupPhoto: "",
  aFrameFoundationPhoto: "",
  ventOpenerPhoto: "",
  aluminiumShadeNetPullyPhoto: "",
  exhaustFanPhoto: "",
  cellusePadPhoto: "",
  waterPumpPhoto: "",
  waterPumpDrainagePhoto: "",
  oxigenationPumpPhoto: "",
  uvLightPhoto: "",
  diskFilterPhoto: "",
  sandFilterPhoto: "",
  foggerAssemblyPhoto: "",
  customerPhotoWithSetUp: "",
  customerFeedbackVideo: "",

  // --- CEA ---------

  ceaCabinOutsidePhoto: "",
  ceaOutsideGutterSidePhoto: "",
  ceaOutsideNonGutterSidePhoto: "",
  ceaGutterSidePhoto: "",
  ceaNonGutterSidePhoto: "",
  ceaSide1VentHandlePhoto: "",
  ceaSide2VentHandlePhoto: "",
  ceaSide3VentHandlePhoto: "",
  ceaSide4VentHandlePhoto: "",
  ceaShadeNetClosedPhoto: "",
  ceaShadeNetOpenPhoto: "",
  ceaWeedmatPhoto: "",
  ceaAcfPhoto: "",

  // --- Fogger Assembly--

  foggerTankPhoto: "",
  foggerMotorPhoto: "",
  foggerDiskFilterPhoto: "",
  foggerTakeOffPhoto: "",
  foggerOnStatePhoto: "",
  foggerTimerPhoto: "",

  //-----Flatbed Assembly--

  flatbedPipesPhoto: "",
  flatbedFramePhoto: "",
  flatbedWaterTankPhoto: "",
  flatbedWaterTankInletValvePhoto: "",
  flatbedWaterPumpPhoto: "",
  flatbedWaterRecollectionPipePhoto: "",
  flatbedNetcupPhoto: "",
  flatbedWaterFlowFromRoPipePhoto: "",
  flatbedTimerPhoto: "",

  //-----GrowBags (Hydroponics)--

  growbagsTankPhoto: "",
  growbagsMotorPhoto: "",
  growbagsDiskFilterPhoto: "",
  growbagsTakeOffPhoto: "",
  growbagsOnStatePhoto: "",
  growbagsArrowDripperPhoto: "",
  growbagsDripPipeEndPhoto: "",
  growbagsTimerPhoto: "",
  growbagTrellisingPhoto: "",
  growbagJHookPhoto: "",

  //----Upload Viedos--

  ceaOutsideAssemblyVideo: "",
  sideVentOperatingVideo: "",
  enteringInsideCeaVideo: "",
  flatbedEntireAssemblyVideo: "",
  growbagsEntireAssemblyVideo: "",
};
export const ClientFeedbackInfo = {
  feedBackStatus: "",
  clientName: "",
  clientContactNumber: "",
  clientEmail: "",
  origin: "",
  dataInsufficient: false,
  leadOwner: "",
  feedback: "",
  experience: "",
  rating: "",
  obstracle: "",
  followUp: false,
  followUpDate: "",
};
export const InsentiveInfo = {
  leadName: "",
  product: "",
  preGstAmount: "",
  paidStatus: "pending",
  incentiveDescription: "",
  sellsType: "",
  revenueApproved: "Pending",
  incentiveAmount: "",
  paymentReceipt: "",
  paymentMode: "",
  paymentDate: "",
  contactNumber: "",
  clientEmail: "",
  clientName: "",
  leadId: "",
  contact_number: "",
  lead_owner: "",
  finalPayment: false,
};
export const ProjectSpecificationInfo = {
  project: "",
  ceaType: "",
  psBaySize: "",
  psSpanSize: "",
  aFramePercent: "",
  flatBedPercent: "",
  growBagPercent: "",
  dutchBucketPercent: "",
  hocky: true,
  notes: "",
  hockyPresense: ["north", "south", "east", "west"],
  standardMaterial: [
    {
      item: "Kryzen Biotech Board",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Filter",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Kryzen Biotech Board Legs",
      hsn: "",
      quantity: 2,
      units: "Nos.",
      gstPer: 18,
      specification: "3 Ft - 1.6mm - Sqaure Tube GI",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Zip tie",
      hsn: "",
      quantity: 5,
      units: "Packets",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "UV Light CUV-135",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Binding Wire",
      hsn: "",
      quantity: 2,
      units: "Kg",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Water Inlet Valve",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "GI Wire",
      hsn: "",
      quantity: 2,
      units: "Kg",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
  ],
  foggerAssembly: [
    {
      item: "Number of Foggers",
      hsn: "",
      quantity: 20,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Fogger lines",
      hsn: "",
      quantity: 4,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Fogger Tank",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Fogger Saddle Piece",
      hsn: "",
      quantity: 4,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Fogger Assembly Block each36mtr",
      hsn: "",
      quantity: 1,
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Fogger Latteral Pipe",
      hsn: "",
      quantity: 1,
      units: "Mtrs",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Fogger Motor",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "16 mm Drill BIT",
      hsn: "",
      quantity: 2,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Fogger Mainline Elbow",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Fogger End Caps",
      hsn: "",
      quantity: 4,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Fogger mainline pipe",
      hsn: "",
      quantity: 21,
      units: "Mtrs.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "FilteFogger Mainline End Cap",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Fogger Timer",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
  ],
  seedlingStation: [
    {
      item: "Number of Stations",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "10ft X 4ft",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Pump",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Timer",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Number of Tanks",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "100Ltr Tank",
      orderType: "",
      vendor: "",
      cogs: "",
    },
  ],
  airCirculationFans: [
    {
      item: "Total Number of Fans",
      hsn: "",
      quantity: 2,
      units: "Nos.",
      gstPer: 18,
      specification: "100Ltr Tank",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Total Fan Wire (Mtr)",
      hsn: "",
      quantity: 40,
      units: "Mtr",
      gstPer: 18,
      specification: "3 Core Duel Insulation",
      orderType: "",
      vendor: "",
      cogs: "",
    },
  ],
  firstBatchStarter: [
    {
      item: "Nursery Black Pro Trays",
      hsn: "",
      quantity: 150,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Cocopeat Block",
      hsn: "",
      quantity: 2,
      units: "Nos.",
      gstPer: 18,
      specification: "Compact Cocopeat Block of 5kg",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Total Number of Fans",
      hsn: "",
      quantity: 2,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Solution A",
      hsn: "",
      quantity: 10,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Solution B",
      hsn: "",
      quantity: 10,
      units: "Ltrs",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "PH Down / PH Up",
      hsn: "",
      quantity: 5,
      units: "Ltrs",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
  ],
  flatbedNFTSystemSpecifications: [
    {
      item: "Flatbed Columns 6mtr",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
    {
      item: "Total Flatbed Blocks 6mtr",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
    {
      item: "NFT pipes 6mtr",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "100mm X 50mm",
      orderType: "",
    },
    {
      item: "Saddle Piece Valve",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "",
      orderType: "",
    },
    {
      item: "Outlet Pipe Spouts to Drainage",
      hsn: "",
      quantity: "",
      units: "Mtrs.",
      gstPer: 18,
      specifications: "",
      orderType: "",
    },
    {
      item: "Underground Inlet Pipe",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: '(2" Pvc Pipe 20Ft)',
      orderType: "",
    },
    {
      item: "Flatbed Column 4mtr",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
    {
      item: "Total Flatbed Blocks 4mtr",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
    {
      item: "NFT pipes 4mtr",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "100mm X 50mm",
      orderType: "",
    },
    {
      item: "NFT Inlet threded T",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "(1/2 upvc Treaded Tee)",
      orderType: "",
    },
    {
      item: "NFT Inlet 1/2 pipe",
      hsn: "",
      quantity: "",
      units: "Mtrs.",
      gstPer: 18,
      specifications: "",
      orderType: "",
    },
    {
      item: "NFT Water Tank",
      hsn: "",
      quantity: "",
      units: "Ltrs.",
      gstPer: 18,
      specifications: "Total water tank capacity",
      orderType: "",
    },
    {
      item: "Underground Drainage Pipe",
      hsn: "",
      quantity: "",
      units: "Mtrs.",
      gstPer: 18,
      specifications: '(3" Pvc Drainage Pipe) Mtr',
      orderType: "",
    },
    {
      item: "Total Number of Flatbed",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "Manufactured as per standard design",
      orderType: "",
    },
    {
      item: "total Flatbed Blocks",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
    {
      item: "Streight Connector",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "Reducer : 1/2 = 1/4",
      orderType: "",
    },
    {
      item: 'Saddle Piece 1/2"',
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "",
      orderType: "",
    },
    {
      item: "6mm RO Pipe",
      hsn: "",
      quantity: "",
      units: "Mtrs.",
      gstPer: 18,
      specifications: "6 MM LateraL white (1/4 inch)",
      orderType: "",
    },
    {
      item: "Water Centrifugal Motors",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "1.5hp Above Tank Copper",
      orderType: "",
    },
    {
      item: "Underground Drainage T",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "Foodgrade uPVC",
      orderType: "",
    },
    {
      item: "NFT End caps",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "Foodgrade uPVC",
      orderType: "",
    },
    {
      item: "NFT Spouts",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "Foodgrade uPVC",
      orderType: "",
    },
    {
      item: "NFT Connector RO-T",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "Foodgrade uPVC",
      orderType: "",
    },
    {
      item: "NFT RO-Key",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "Foodgrade uPVC",
      orderType: "",
    },
    {
      item: "NFT Out-T",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "Foodgrade uPVC",
      orderType: "",
    },
    {
      item: "Analogue Timer",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "Foodgrade uPVC",
      orderType: "",
    },
    {
      item: "NFT Inlet T",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specifications: "Foodgrade uPVC",
      orderType: "",
    },
  ],
  aFrameNftSystemSpecification: [
    {
      item: "A frame Columns 6mtr",
      hsn: "",
      quantity: 3,
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Total A Frame Blocks 6mtr",
      hsn: "",
      quantity: 24,
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "NFT pipes 6mtr",
      hsn: "",
      quantity: 2016,
      units: "Nos.",
      gstPer: 18,
      specification: "100mm X 50mm",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "A frame Bottom Fastner",
      hsn: "",
      quantity: 576,
      units: "Nos.",
      gstPer: 18,
      specification: "(10 x 125 Fastner)",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Saddle Piece Valve",
      hsn: "",
      quantity: 24,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Outlet Pipe Spouts to Drainage",
      hsn: "",
      quantity: 6,
      units: "Mtrs.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Underground Inlet Pipe",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specification: '(2" Pvc Pipe 20Ft)',
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "A frame Column 4mtr",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Total A Frame Blocks 4mtr",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "NFT pipes 4mtr",
      hsn: "",
      quantity: "",
      units: "Nos.",
      gstPer: 18,
      specification: "100mm X 50mm",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "NFT Inlet threded T",
      hsn: "",
      quantity: 168,
      units: "Nos.",
      gstPer: 18,
      specification: "(1/2 upvc Treaded Tee)",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "NFT Inlet 1/2 pipe",
      hsn: "",
      quantity: 65.76,
      units: "Mtrs.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "NFT Water Tank",
      hsn: "",
      quantity: 6000,
      units: "Ltrs.",
      gstPer: 18,
      specification: "Total water tank capacity",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Underground Drainage Pipe",
      hsn: "",
      quantity: 69,
      units: "Mtrs.",
      gstPer: 18,
      specification: '(3" Pvc Drainage Pipe) Mtr',
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Total Number of A-Frames",
      hsn: "",
      quantity: 144,
      units: "Nos.",
      gstPer: 18,
      specification: "Manufactured as per standard design",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "total A-Frame Blocks",
      hsn: "",
      quantity: 24,
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Streight Connector",
      hsn: "",
      quantity: 168,
      units: "Nos.",
      gstPer: 18,
      specification: "Reducer : 1/2 = 1/4",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: 'Saddle Piece 1/2"',
      hsn: "",
      quantity: 24,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "6mm RO Pipe",
      hsn: "",
      quantity: 201.6,
      units: "Mtrs.",
      gstPer: 18,
      specification: "6 MM LateraL white (1/4 inch)",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Water Centrifugal Motors",
      hsn: "",
      quantity: 2,
      units: "Nos.",
      gstPer: 18,
      specification: "1.5hp Above Tank Copper",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Underground Drainage T",
      hsn: "",
      quantity: 3,
      units: "Nos.",
      gstPer: 18,
      specification: "Foodgrade uPVC",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "NFT End caps",
      hsn: "",
      quantity: 336,
      units: "Nos.",
      gstPer: 18,
      specification: "Foodgrade uPVC",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "NFT Spouts",
      hsn: "",
      quantity: 336,
      units: "Nos.",
      gstPer: 18,
      specification: "Foodgrade uPVC",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "NFT Connector RO-T",
      hsn: "",
      quantity: 168,
      units: "Nos.",
      gstPer: 18,
      specification: "Foodgrade uPVC",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "NFT RO-Key",
      hsn: "",
      quantity: 336,
      units: "Nos.",
      gstPer: 18,
      specification: "Foodgrade uPVC",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "NFT Out-T",
      hsn: "",
      quantity: 336,
      units: "Nos.",
      gstPer: 18,
      specification: "Foodgrade uPVC",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Analogue Timer",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "Foodgrade uPVC",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "NFT Inlet T",
      hsn: "",
      quantity: 3,
      units: "Nos.",
      gstPer: 18,
      specification: "Foodgrade uPVC",
      orderType: "",
      vendor: "",
      cogs: "",
    },
  ],
  waterTankAssemblyforAFrame: [
    {
      item: 'Hose Pipe Clip 1"',
      hsn: "",
      quantity: 4,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: 'Hose Pipe 1"',
      hsn: "",
      quantity: 2,
      units: "Nos.",
      gstPer: 18,
      specification: "10ft long pipe",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Hose Nipple 1inch X 1inch",
      hsn: "",
      quantity: 2,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Oxygen Stone",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Oxygen Tube",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Oxygen Pump",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "10ft long Oxygen pipe tube",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Oxygen Pump Timer",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
  ],
  plumbingAdhesive: [
    {
      item: "PVC Adhesive Solution",
      hsn: "",
      quantity: 1,
      units: "Ltrs",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "UPVC Adhesive Solution",
      hsn: "",
      quantity: 1,
      units: "Ltrs",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Silicon Injection Tube",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Teflon Tape",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
  ],
  handBookAndManual: [
    {
      item: "Printed Manual of Items",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Warranty Manual",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "pH Meter",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "EC Meter",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "PH Stripes",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Temprature Clock",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Software Logins",
      hsn: "",
      quantity: 1,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "HM Codes / Labour Training",
      hsn: "",
      quantity: 3,
      units: "Nos.",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
  ],
  aFrameBlockSpecification: [
    {
      item: "Total Blocks Available of A Frame",
      hsn: "",
      quantity: 10,
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "A frames single line",
      hsn: "",
      quantity: 2.85,
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Adjusted A Frame Length",
      hsn: "",
      quantity: 21,
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "A frame rows",
      hsn: "",
      quantity: 8,
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "A Frame complete Usable length",
      hsn: "",
      quantity: 14,
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "A Frame Access Length",
      hsn: "",
      quantity: 6,
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "A frame Unusable length",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: 18,
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
  ],
  flatBedBlockSpecifications: [
    {
      item: "Total Blocks Available of Flatbed",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "A frames single line",
      hsn: "",
      quantity: 2.857142857,
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Adjusted Flatbed Length",
      hsn: "",
      quantity: 21,
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Flatbed rows",
      hsn: "",
      quantity: 8,
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Flatbed complete Usable length",
      hsn: "",
      quantity: 14,
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Flatbed Access Length",
      hsn: "",
      quantity: 6,
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Flatbed Unusable length",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
  ],
  growBagsBlockSpecifications: [
    {
      item: "Total Blocks Available of Growbags",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Growbags single line",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Adjusted Growbags Length",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Growbags rows",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Growbags complete Usable length",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Growbags Access Length",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    {
      item: "Growbags Unusable length",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specification: "",
      orderType: "",
      vendor: "",
      cogs: "",
    },
    // Add more items as needed
  ],
  dutchBucketBlockSpecification: [
    {
      item: "Total Blocks Available of Dutch Bucket",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
    {
      item: "Dutch Bucket single line",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
    {
      item: "Adjusted Dutch Bucket Length",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
    {
      item: "Dutch Bucket rows",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
    {
      item: "Dutch Bucket complete Usable length",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
    {
      item: "Dutch Bucket Access Length",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
    {
      item: "Dutch Bucket Unusable length",
      hsn: "",
      quantity: "",
      units: "Program Count",
      gstPer: "",
      specifications: "",
      orderType: "",
    },
  ],
};

export const BuyersReportInfo = {
  report: [],
};

export const WorkforceCreateInfo = {
  firstName: "",
  lastName: "",
  emailAddress: "",
  dateOfJoining: "",
  dateOfBirth: "",
  contactNumber: "",
  aadharNumber: "",
  panNumber: "",
  permanentAddress: "",
  emergencyContactName: "",
  emergencyContactNumber: "",
  emergencyContactRelation: "",
  uploadPhoto: "",
  uploadAadharFront: "",
  uploadAadharBack: "",
  salary: "",
  salaryFrequency: "",
  salaryFrequencyType: "",
};

export const AssetsCreateInfo = {
  resourceName: "",
  companyName: "",
  vendor: "",
  deploymentDate: "",
  warrantyPeriod: "",
  paymentAmount: "",
  paymentMode: "",
  uploadBill: "",
  uploadWarrantyCard: "",
  notes: "",
  uploadProductPhoto: "",
};

export const InventoryCreateInfo = {
  assetName: "",
  companyName: "",
  vendor: "",
  refillFrequency: "",
  refillFrequencyType: "",
  frequencyCycle: "",
  paymentAmount: "",
  paymentMode: "",
  uploadBill: "",
  notes: "",
  uploadProductPhoto: "",
};
export const ReimbursementInfo = {
  amount: "",
  addRecipt_bill: "",
  paid_bill: "",
  selectProject: "",
  reimbursementsDescription: "",
  generatedBy: "",
  paidStatus: "pending",
  incentiveDescription: "",
  modeOfPayment: "",
  customClientName: "",
};

export const QuotationMatrixInfo = {
  type: "",
  factor: "",
  unit: "",
  description: "",
  basePrice0To100: 0,
  basePrice101To200: 0,
  basePrice201To400: 0,
  basePrice401To500: 0,
  basePrice501To1000: 0,
  basePrice1001To1500: 0,
  basePrice1501To2000: 0,
  basePrice2001To2500: 0,
  basePrice2501To3000: 0,
  basePrice3001To3500: 0,
  basePrice3501To4000: 0,
  basePrice4001To4500: 0,
  basePrice4501To5000: 0,
  basePrice5001To5500: 0,
  basePrice5501To6000: 0,
  basePrice6001To6500: 0,
  basePrice6501To7000: 0,
  basePrice7001To7500: 0,
  basePrice7501To8000: 0,
  basePriceGreater8000: 0,
  sqMtrWeed: 0,
  markupPercent0To100: 0,
  markupPercent101To200: 0,
  markupPercent201To400: 0,
  markupPercent401To500: 0,
  markupPercent501To1000: 0,
  markupPercent1001To1500: 0,
  markupPercent1501To2000: 0,
  markupPercent2001To2500: 0,
  markupPercent2501To3000: 0,
  markupPercent3001To3500: 0,
  markupPercent3501To4000: 0,
  markupPercent4001To4500: 0,
  markupPercent4501To5000: 0,
  markupPercent5001To5500: 0,
  markupPercent5501To6000: 0,
  markupPercent6001To6500: 0,
  markupPercent6501To7000: 0,
  markupPercent7001To7500: 0,
  markupPercent7501To8000: 0,
  markupPercentGreater8000: 0,
};

export const SiteInspectionFeedbackInfo = {
  schedulingExperience: "",
  agentOnTime: "",
  queriesAnswered: "",
  landSurvey: "",
  climateInfo: "",
  notes: "",
};

export const AgriwikiLineInfo = {
  companyName: "",
  seedsPhoto: "",
};

export const AgronomyWikiInfo = {
  name: "",
  articleType: "",
  classification: "",
  subCategory: "",
  scientificName: "",
  description: "",
  seedUrl: "",
  seedlingDuration: "",
  minGrowingTemperature: "",
  maxGrowingTemperature: "",
  minGrowingHumidity: "",
  maxGrowingHumidity: "",
  minPh: "",
  maxPh: "",
  minTds: "",
  maxTds: "",
  seedGerminationDays: "",
  twoLeavesDays: "",
  canPrune: false,
  generalServingSize: "",
  image: "",
  proneToPowderyMildew: false,
  proneToDownyMildew: false,
  proneToFusariumWilt: false,
  proneToAnthracnose: false,
  proneToRootRot: false,
  proneToLeafSpot: false,
  proneToBotrytisRot: false,
  proneToBacterialLeafSpot: false,
  proneToMosaicVirus: false,
  proneToLeafCurleVirus: false,
  proneToClubRoot: false,
  productionPerPlantPerCycle: false,
  difficultyToGrowInWinter: "",
  difficultyToGrowInSpring: "",
  difficultyToGrowInSummer: "",
  difficultyToGrowInMonsoon: "",
  difficultyToGrowInAutumn: "",
  difficultyToGrowInPrewinter: "",
  favouriteOnly: false,
  pestanddisease: [],
  ApplicableToPMG: false,
  plantPriceForFarmer: "",
  plantPriceForCustomer: "",
  lineItems: [],
  cropSeason: "",
};

export const BuyersManagementInfo = {
  photo: "",
  name: "",
  email: "",
  description: "",
  yearEstablished: "",
  fssaiNumber: "",
  varifiedBadge: false,
  isWholesaler: false,
  isRetailer: false,
  isTrader: false,
  isExporter: false,
  isFoodProcessor: false,
  dealPerishableVegetables: false,
  dealExoticVegetables: false,
  dealFruitsAndBerries: false,
  dealDryFruits: false,
  dealGrains: false,
  buyerRating: "",
  creditScore: "",
  deliveryRoad: false,
  deliveryRail: false,
  deliverySea: false,
  deliveryCargo: false,
  phoneNumber1: "",
  phoneNumber2: "",
  addressLine1: "",
  addressState: "",
  addressPincode: "",
  openOnMonday: false,
  openOnTuesday: false,
  openOnWednesday: false,
  openOnThursday: false,
  openOnFriday: false,
  openOnSaturday: false,
  openOnSunday: false,
  operationalHoursMonday: "",
  operationalHoursTuesday: "",
  operationalHoursWednesday: "",
  operationalHoursThursday: "",
  operationalHoursFriday: "",
  operationalHoursSaturday: "",
  operationalHoursSunday: "",
  googleMapLink: "",
  market: "",
  report: [],
  openForLtc: false,
  cropName: "",
  cropPhoto: "",
  purchaseFrequency: "",
  purchaseFrequencyType: "",
  pricing: "",
  ltcDuration: "",
  ltcDurationType: "",
  purchaseQuantity: "",
};

export const FarmSupportInfo = {
  queryRaised: "",
  relatedTo: "",
  image: "",
  message: "",
  generatedBy: "",
  assignedName: "",
};

export const lineItemInvoiceInfo = {
  particulars: "",
  totalWithoutGst: "",
  totalWithGst: "",
  itemUnit: "",
  itemQuantity: "",
  discount: "",
  HSN: "",
  itemPrice: "",
  gstRate: "",
};

export const ClientInvoiceInfo = {
  clproject: "",
  clquotation: "",
  invoiceType: "proforma invoice",
  invoiceDate: today.toISOString().substr(0, 10),
  totalAmountIncGst: "0.0",
  businessName: "",
  contactPersonName: "",
  phoneNumber: "",
  gstNumber: "",
  address: "",
  countryOfSupply: "india",
  placeOfSupply: "",
  invoiceFor: "",
  totalGst: "0.0",
  notes: "",
  generatedBy: "",
  pdfStatus: false,
  lineItems: [],
  shippingAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    pincode: "",
    state: "Maharashtra",
    country: "India",
  },
  billingAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    pincode: "",
    state: "Maharashtra",
    country: "India",
  },
  clId: "",
  manualInvoiceNumber: "",
  terms_conditions: `All prices are in INR.
Work will start after advance payment.
Advance shall be treated as a work order.
Rates are based on current steel and PVC raw material prices.
Transportation and labour ticket charges are extra.
Any additional services will be charged separately.`,
};

export const lineItemEstimateInfo = {
  particulars: "",
  totalWithoutGst: "",
  totalWithGst: "",
  itemUnit: "",
  itemQuantity: "",
  discount: "",
  HSN: "",
  itemPrice: "",
  gstRate: "",
};

export const EstimateInfo = {
  clproject: "",
  clquotation: "",
  invoiceType: "proforma invoice",
  invoiceDate: today.toISOString().substr(0, 10),
  totalAmountIncGst: "0.0",
  businessName: "",
  contactPersonName: "",
  phoneNumber: "",
  gstNumber: "",
  address: "",
  countryOfSupply: "india",
  placeOfSupply: "",
  invoiceFor: "",
  totalGst: "0.0",
  notes: "",
  generatedBy: "",
  pdfStatus: false,
  lineItems: [],
};

export const FarmTrainingInfo = {
  name: "",
  email: "",
  contactNumber: "",
  watsapppNumber: "",
  enrollDate: "",
  farmTrainingDate: "",
  amountPaid: "",
  modeOfPayment: "",
  foodPreference: "",
  hotelBooked: "",
  upgradeRequest: [],
  clientType: [],
  farmTrainingLocation: "",
  farmTrainingLocationUrl: "",
  generatedBy: "",
  refundRequested: false,
};

export const MarketingList = {
  MarketingList: "",
  MarketingCampaign: "",
  ScheduleDate: "",
  Thresholds: "",
};

export const WaterManagement = {
  cycleName: "",
  typeOfSystem: "",
  waterTankCapacity: "",
  startingPh: "",
  startingEc: "",
  waterSource: "",
  timeLines: [],
};

export const TimeLineWaterManagementInfo = {
  phReading: "",
  ecReading: "",
  scheduleDate: "",
};
export const scheduleInfo = {
  date: "",
  schedule: "",
  actions: "",
  scheduleDone: false,
  scheduleDoneDate: "",
  cropUploadPhoto: "",
};
export const nurseryBatchInfo = {
  batchName: "",
  cropName: "",
  numberOfplants: "",
  batchStartDate: "",
  batchEndDate: "",
  schedule: [],
  notes: "",
  generatedBy: "",
  cropPackFront: "",
  cropPackBack: "",
};

export const taskManagementInfo = {
  name: "",
  description: "",
  assignTo: [],
  deadline: "",
  status: "pending",
  feedback: "",
  taskType: "",
  startDate: "",
  frequency: "",
  frequencyType: "",
  weekDays: "",
  remarks: "",
  generatedBy: "",
  uploadImage: "",
  endDate: "",
  priority: "P3",
  taskDifficulty: "",
};

export const priceWatcherInfo = {
  plantName: "",
  plantId: "",
  week: "",
  weekStartDate: "",
  weekEndDate: "",
  weeklyPrice: "",
  month: "",
  year: "",
  season: "",
};

export const boomsSpecificationInfo = {
  itemName: "",
  itemDescription: "",
  itemQuantityType: "",
  needTransportation: false,
  needPackaging: false,
  vendors: [],
};

export const vendorsboms = {
  vendorName: "",
  itemMinPrice: "",
  itemMaxPrice: "",
};

export const hardvestCreateInfo = {
  harvestDate: "",
  selectCrop: "",
  harvestQuantity: "",
  packagingType: "",
  sellingPricePerKg: "",
  uploadProductPhoto: "",
  transportation: "",
};

export const cropUpdateInfo = {
  cropName: "",
  cropCycleName: "",
  typeOfSystem: "",
  ceaSystem: "",
  waterTankCapacity: "",
  cropCycleStartDate: "",
  totalCropCount: "",
  cropPhoto: [],
};

export const cropPhotosInfo = {
  cropUploadPhoto: "",
  updateDate: new Date().toISOString().split("T")[0],
};

export const pestDiseaseInfo = {
  diseasesName: "",
  typeOfDiseases: "",
  image: "",
  description: "",
  productToUse: "",
  productPhoto: "",
  productLink: "",
  usageOfProduct: "",
  usageOfProductModerate: "",
  productToUseModerate: "",
  productPhotoModerate: "",
  productLinkModerate: "",
  usageOfProductWild: "",
  productToUseWild: "",
  productPhotoWild: "",
  productLinkWild: "",
  usageOfProductOrganic: "",
  productToUseOrganic: "",
  productPhotoOrganic: "",
  productLinkOrganic: "",
};

export const onboardHydrobuildInfo = {
  UID: "",
  Watertankcapacity: "",
  FertiliserSolutiontype: "",
  FertilisersolutionPPM: "",
  cropId: "",
};

export const webinarOrderInfo = {
  personName: "",
  amount: 299,
  // receipt: "",
  date: "",
  email: "",
  contact: "",
  city: "",
  gender: "male",
  age: "",
};
export const createWebinarInfo = {
  webinarName: "",
  webinarStartTime: "7:00 PM",
  webinarEndTime: "9:00 PM",
  speakerInfo: "",
  webinarThumbnail: "",
  webinarDate: "",
  description: "",
};

export const HydrobuildRunmachanismInfo = {
  kitId: "",
  tankA: "",
  tankAEndTime: "",
  tankAStartTime: "",
  tankAStartDate: "",
  tankAEndDate: "",
  tankAOffDuration: "",
  tankAOffTime: "",
  tankAOnDuration: "",
  tankAOnTime: "",
  minAppm: "",
  maxAppm: "",
  minAph: "",
  maxAph: "",

  tankB: "",
  tankBEndTime: "",
  tankBStartTime: "",
  tankBStartDate: "",
  tankBEndDate: "",
  tankBOffDuration: "",
  tankBOffTime: "",
  tankBOnDuration: "",
  tankBOnTime: "",
  minBppm: "",
  maxBppm: "",
  minBph: "",
  maxBph: "",

  tankPhDown: "",
  tankPhDownEndTime: "",
  tankPhDownStartTime: "",
  tankPhDownStartDate: "",
  tankPhDownEndDate: "",
  tankPhDownOffDuration: "",
  tankPhDownOffTime: "",
  tankPhDownOnDuration: "",
  tankPhDownOnTime: "",
  minPhDownppm: "",
  maxPhDownppm: "",
  minPhDownph: "",
  maxPhDownph: "",
};

export const materialPlaningInfo = {
  foundation: {
    materialType: "GI Pipe",
    itemName: "Foundation",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 60,
    lengthInMeters: 1,
  },

  bigColumn: {
    materialType: "GI Pipe",
    itemName: "Big Column",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 76,
    lengthInMeters: 6.5,
  },

  smallColumn: {
    materialType: "GI Pipe",
    itemName: "Small Column",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 76,
    lengthInMeters: 4.5,
  },

  bigBottom: {
    materialType: "GI Pipe",
    itemName: "Big Bottom",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 60,
    lengthInMeters: 8,
  },

  smallBottom: {
    materialType: "GI Pipe",
    itemName: "Small Bottom",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 60,
    lengthInMeters: 4,
  },

  hockey: {
    materialType: "GI Pipe",
    itemName: "Hockey",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 48,
    lengthInMeters: 5.5,
  },

  bracingRod: {
    materialType: "GI Pipe",
    itemName: "Bracing Rod",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 48,
    lengthInMeters: 2,
  },

  bigArc: {
    materialType: "GI Pipe",
    itemName: "Big Arc",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 42,
    lengthInMeters: 6,
  },

  smallArc: {
    materialType: "GI Pipe",
    itemName: "Small Arc",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 42,
    lengthInMeters: 4.5,
  },

  endArc: {
    materialType: "GI Pipe",
    itemName: "End Arc",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 42,
    lengthInMeters: 5.2,
  },

  topPurline: {
    materialType: "GI Pipe",
    itemName: "Top Purline",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 48,
    lengthInMeters: 4,
  },

  secondPurline: {
    materialType: "GI Pipe",
    itemName: "Second Purline",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 48,
    lengthInMeters: 4,
  },

  gutterPurline4m: {
    materialType: "GI Pipe",
    itemName: "Gutter Purline",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 42,
    lengthInMeters: 4,
  },

  gutterPurline6m: {
    materialType: "GI Pipe",
    itemName: "Gutter Purline",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 42,
    lengthInMeters: 6,
  },

  endPurline: {
    materialType: "GI Pipe",
    itemName: "End Purline",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 42,
    lengthInMeters: 4,
  },

  hockeyMember: {
    materialType: "GI Pipe",
    itemName: "Hockey Member",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 42,
    lengthInMeters: 4,
  },

  hockeyRunner: {
    materialType: "GI Pipe",
    itemName: "Hockey Runner",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 33,
    lengthInMeters: 1.2,
  },

  tieBar: {
    materialType: "GI Pipe",
    itemName: "Tie Bar",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 33,
    lengthInMeters: 4,
  },

  crossBar: {
    materialType: "GI Pipe",
    itemName: "Cross Bar",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 33,
    lengthInMeters: 5,
  },

  wBig: {
    materialType: "GI Pipe",
    itemName: "W - Big",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 33,
    lengthInMeters: 2,
  },

  wMedium: {
    materialType: "GI Pipe",
    itemName: "W - Medium",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 33,
    lengthInMeters: 2,
  },

  wSmall: {
    materialType: "GI Pipe",
    itemName: "W - Small",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 33,
    lengthInMeters: 2,
  },

  vent: {
    materialType: "GI Accessories",
    itemName: "Vent",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 19,
    lengthInMeters: 6,
  },

  flapControl: {
    materialType: "GI Accessories",
    itemName: "Flap Control",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 19,
    lengthInMeters: 3,
  },

  handles: {
    materialType: "GI Accessories",
    itemName: "Handles",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 19,
    lengthInMeters: 3,
  },

  fBracket: {
    materialType: "GI Accessories",
    itemName: "F Bracket",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  lPipe: {
    materialType: "GI Accessories",
    itemName: "L Pipe",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  tPipe: {
    materialType: "GI Accessories",
    itemName: "T Pipe",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  lBracket: {
    materialType: "GI Accessories",
    itemName: "L Bracket",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  handleLock: {
    materialType: "GI Accessories",
    itemName: "Handle_Lock",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  selfTappingScrew: {
    materialType: "GI Accessories",
    itemName: "Self Tapping Screw",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  studPipe: {
    materialType: "GI Accessories",
    itemName: "Stud Pipe",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  holFast: {
    materialType: "GI Accessories",
    itemName: "Hol Fast",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  shadenetPulley: {
    materialType: "GI Accessories",
    itemName: "Shadenet Pulley",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  springTar: {
    materialType: "GI Accessories",
    itemName: "Spring Tar",
    quantity: "",
    quantityUnit: "mts",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  giTar12: {
    materialType: "GI Accessories",
    itemName: "G.I. Tar (12 Gauge)",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  giTar14: {
    materialType: "GI Accessories",
    itemName: "G.I. Tar (14 Gauge)",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  ropes: {
    materialType: "GI Accessories",
    itemName: "Ropes",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  ring: {
    materialType: "GI Accessories",
    itemName: "Ring",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  doorSupportRod: {
    materialType: "GI Accessories",
    itemName: "Door Support rod",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  doorSection: {
    materialType: "GI Accessories",
    itemName: "Door Section",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 4,
  },

  rollerBox: {
    materialType: "GI Accessories",
    itemName: "Roller Box",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  fullClamp76: {
    materialType: "GI Accessories",
    itemName: "Full Clamp (76mm)",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  fullClamp60: {
    materialType: "GI Accessories",
    itemName: "Full Clamp (60mm)",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  fullClamp48: {
    materialType: "GI Accessories",
    itemName: "Full Clamp (48mm)",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  fullClamp42: {
    materialType: "GI Accessories",
    itemName: "Full Clamp (42mm)",
    quantity: "",
    quantityUnit: "pcs",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  halfClamp76: {
    materialType: "GI Accessories",
    itemName: "Half Clamp (76mm)",
    quantity: "",
    quantityUnit: "pair",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  halfClamp60: {
    materialType: "GI Accessories",
    itemName: "Half Clamp (60mm)",
    quantity: "",
    quantityUnit: "pair",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  halfClamp42: {
    materialType: "GI Accessories",
    itemName: "Half Clamp (42mm)",
    quantity: "",
    quantityUnit: "pair",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  s10By150: {
    materialType: "GI Accessories",
    itemName: "10_By_150",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  s10By100: {
    materialType: "GI Accessories",
    itemName: "10_By_100",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  s10By80: {
    materialType: "GI Accessories",
    itemName: "10_By_80",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  s10By60: {
    materialType: "GI Accessories",
    itemName: "10_By_60",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  s10By40: {
    materialType: "GI Accessories",
    itemName: "10_By_40",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  s8By100: {
    materialType: "GI Accessories",
    itemName: "8_By_100",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  s6By60: {
    materialType: "GI Accessories",
    itemName: "6_By_60",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  bolt10: {
    materialType: "GI Accessories",
    itemName: "10 Bolt",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  bolt6: {
    materialType: "GI Accessories",
    itemName: "6 Bolt",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },

  bolt8: {
    materialType: "GI Accessories",
    itemName: "8 Bolt",
    quantity: "",
    quantityUnit: "kg",
    weight: "",
    weightUnit: "kg",
    rate: "",
    diameterInMM: 0,
    lengthInMeters: 0,
  },
};

export const softMaterialPlanningInfo = {
  gutter: {
    itemName: "Gutter",
    width: 0,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "pcs",
  },

  door: {
    itemName: "Door",
    width: 0,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "pcs",
  },

  profile: {
    itemName: "Profile",
    width: 0,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "mts",
  },

  topPolyfilm: {
    itemName: "Top Polyfilm",
    width: 5.5,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "pcs",
  },

  secondPolyfilm: {
    itemName: "Second Polyfilm",
    width: 4.5,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "pcs",
  },

  gable: {
    itemName: "Gable",
    width: 5.5,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "pcs",
  },

  frontBackCurtain: {
    itemName: "FrontBack Curtain",
    width: 4.5,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "pcs",
  },
  gutterSide: {
    itemName: "Gutter Side",
    width: 4.5,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "pcs",
  },
  cornerPaper: {
    itemName: "Corner Paper",
    width: 0,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "pcs",
  },
  topShadeNet: {
    itemName: "Top ShadeNet (50%)",
    width: 4.2,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "pcs",
  },
  insectNet1: {
    itemName: "Insect Net 1",
    width: 3,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "",
  },
  insectNet2: {
    itemName: "Insect Net 2",
    width: 3,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "",
  },
  apprun1: {
    itemName: "Apprun 1",
    width: 2,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "",
  },
  apprun2: {
    itemName: "Apprun 2",
    width: 2,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "",
  },
  shadeNet1: {
    itemName: "ShadeNet (35%) 1",
    width: 4.5,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "",
  },
  shadeNet2: {
    itemName: "ShadeNet (35%) 2",
    width: 4.5,
    length: "",
    quantity: "",
    perQuantityArea: "",
    totalArea: "",
    rate: "",
    quantityUnit: "",
  },
  pollyhouseDesign1: "",
  pollyhouseDesign2: "",
};

export const toBeProducedInfo = {
  s76_6p5m: {
    itemName: "76_(6.5m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s76_4p5m: {
    itemName: "76_(4.5m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s60_8m: {
    itemName: "60_(8m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s60_6m: {
    itemName: "60_(6m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s60_5p5m: {
    itemName: "60_(5.5m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s60_4m: {
    itemName: "60_(4m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s48_6m: {
    itemName: "48_(6m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s48_4m: {
    itemName: "48_(4m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s42_6p5m: {
    itemName: "42_(6.5m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s42_6m1: {
    itemName: "42_(6m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s42_6m2: {
    itemName: "42_(6m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s42_5p2m: {
    itemName: "42_(5.2m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s42_5m: {
    itemName: "42_(5m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s42_4p5m: {
    itemName: "42_(4.5m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s42_4m: {
    itemName: "42_(4m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s33_6m: {
    itemName: "33_(6m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s33_5m: {
    itemName: "33_(5m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s33_4m: {
    itemName: "33_(4m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s27_6m: {
    itemName: "27_(6m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
  s19_6m: {
    itemName: "19_(6m)",
    s3mm: 0,
    s2p9mm: 0,
    s2p6mm: 0,
    s2mm: 0,
    s1p8mm: 0,
    s1p6mm: 0,
  },
};

export const IventoryPlantInfo = {
  productId: "",
  variantId: "",
  quantity: 1,
};

export const IventoryPlantInfoUpdate = {
  quantity: 1,
};

export const FarmerShopInfo = {
  accId: "",
  quantity: "",
  totalAmount: 0,
  shippingAddress: {
    city: "",
    state: "",
    address: "",
    pincode: "",
  },
  paymentDetails: {},
};

export const CnFShopInfo = {
  productId: "",
  accId: "",
  quantity: "",
  totalAmount: 0,
  shippingAddress: {
    city: "",
    state: "",
    address: "",
    pincode: "",
  },
  paymentDetails: {},
};
export const SubsidyDocumentsInfo = {
  clientId: "",
  aadharcardPhotoFront: "",
  aadharcardPhotoBack: "",
  workOrder: "",
  cibilReport: "",
  ITRReport: "",
  castCertificate: "",
  farmerCertificate: "",
  rentalDocuments: "",
  appliedForAIF: false,
};

export const HydroponicMaterialInfo = {
  inStock: 0,
  cost: 0,
  costFromVendor: "",
  invoiceNumber: "",
};

export const CreateBankingDpr = {
  borrowFromBank: 0,
};
export const CreateLeadTrackingInfo = {
  name: "",
  quatationNumber: "",
  siLocation: "",
  clientContact: "",
  clientEmail: "",
  projectArea: "",
};

export const CreateEmployeeFeedback = {
  feedbackType: "",
  feedback: "",
  markAsRead: false,
};

export const CreateNewSI = {
  name: "",
  email: "",
  contactNumber: "",
  watsapppNumber: "",
  enrollDate: "",
  amountPaid: "",
  paymentDate: "",
  Address: "",
  paymentMode: "",
};
export const HMInventoryInfo = {
  item: "",
  hsn: "",
  unit: "",
  productSpecification: "",
  brandName: "",
  count: "",
  shortName: "",
  hydroponicType: "",
  hydroponicTypeNew: [],
  cost: "",
  image: "",
  inStock: "",
  thresholdLimit: "",
  specificationsNew: [],
  specifications: "",
  needTransportation: false,
  needPackaging: false,
  isFragile: false,
  costFromVendor: "",
  location: "",
  rackId: "",
  size: "",
  fabricationProcess: ["repacking"],
  fabricationChargesMarkup: "5",
  handlingCharges: "3",
  optionalWarrantyCovergePerUnit: "1",
  gst: "18",
  weight_unit: "",
  weight: "",
  materialType: "",
  proUnit: "",
  iteminList: false,
};
export const ReqRefundInfo = {
  reqFor: "",
  name: "",
  email: "",
  contactNumber: "",
  paymentReceipt: "",
  message: "",
  reqStatus: "",
  statusFeedback: "",
  accountholderName: "",
  bankName: "",
  accountNumber: "",
  ifcCode: "",
  paymentImage: "",
  webinarId: "",
};
export const SiScheduleByClient = {
  name: "",
  email: "",
  contactNumber: "",
  orderId: "",
  date1: "",
};

export const EmployeeInfoCreate = {
  firstName: "",
  lastName: "",
  gender: "",
  contactNumber: "",
  permanantAddress: "",
  personalEmail: "",
  residentialAddress: "",
  aadharcardNumber: "",
  pancardNumber: "",
  roleInOrganisation: "",
  packageJoinedAt: "",
  dateOfJoining: "",
  isfreeLancer: "",
  position: "",
  city: "",
  interviewDate: "",
  progress: [
    {
      task: "Check Background",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Appointment Letter",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Create Employee Account",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Add Thumb & Explain Attendance System",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Employee Training Program",
      completed: false,
      startDate: "",
      endDate: "",
    },
    { task: "Software Demo", completed: false, startDate: "", endDate: "" },
    {
      task: "Schedule Buddy Meeting & Set Expectations",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Finish Email Branding",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Share Company & Team Guide",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Announce New Employee to Team & Introduce",
      completed: false,
      startDate: "",
      endDate: "",
    },

    {
      task: "Add to WhatsApp Groups",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Collect Photo for Website & Share with IT",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Create Email Account",
      completed: false,
      startDate: "",
      endDate: "",
    },
  ],
  offBoardprogress: [
    {
      task: "Delete Email Id",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Disable The Credentials",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Exit Interview",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Asset Reallocation",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Issue No-Due Certificate",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Issue Experience Letter",
      completed: false,
      startDate: "",
      endDate: "",
    },
    {
      task: "Issue Last 3 Moths Salary Slips",
      completed: false,
      startDate: "",
      endDate: "",
    },
  ],
};

export const ForgotPasswordInfo = {
  email: "",
};

export const FollowersInfo = {
  // hmusers:"",
  instagram: "",
  facebook: "",
  linkedin: "",
  youtube: "",
  google: "",
};

export const FeatureInfo = {
  feature: "",
  description: "",
  accessRoute: "",
  accessRoles: [],
  status: "",
  notes: "",
  conditions: "",
  newlyUpdates: [],
  subFeature: [],
  designBy: "",
  developBy: "",
  backendBy: "",
};

export const WebinarFeedbackInfo = {
  feedbackRating: "",
  feedback: "",
};

export const manualPaymentInitialValues = {
  name: "",
  email: "",
  mobile: "",
  paymentId: "",
  amount: "",
  paymentStatus: "Completed",
  webinarName: "",
  dummyPayment: "",
};

export const applicationFormInfo = {
  Fname: "",
  Lname: "",
  email: "",
  phoneNo: "",
  departments: "",
  jobType: "",
  Etype: "",
  uploadcv: "",
  skills: "",
};

export const agriSubsidyInfo = {
  name: "",
  phoneNo: "",
  state: "",
  district: "",
  taluka: "",
  vName: "",
  empStatus: "",
  farmerId: "",
  subsidy: [],
};

export const ExpenseFormInitialValues = {
  expenditureType: "",
  expenditureCategory: "",
  frequency: "",
  description: "",
  amount: "",
  subCategory: "",
  startDate: "",
  endDate: "",
};

export const StructureUtilizationInfo = {
  projectName: "",
  lengthOfStru: "",
  totalenHocky: "",
  widthOfStru: "",
  totawidHocky: "",
  sideHeight: "",
  centerHeight: "",
  bigColumnLoc: "",
  gutterNum: "",
  gutterLen: "",
  bigColImg: "",
  sideColImg: "",
  northSideHock: "",
  eastSideHock: "",
  westSideHock: "",
  southSideHock: "",
  hockeyToColoumnCount: "",
  lengthOfEntryCabin: "",
  widthOfEntryCabin: "",
  heightOfEntryCabin: "",
  entryCabinDirection: "",
  numOfDoorsEntryCabin: "",

  sideFooterDirectionEast: "East",
  sideFooterApronStatusEast: "",
  sideFooterApronStatusImgEast: "",

  sideFooterDirectionWest: "West",
  sideFooterApronStatusWest: "",
  sideFooterApronStatusImgWest: "",

  sideFooterDirectionNorth: "North",
  sideFooterApronStatusNorth: "",
  sideFooterApronStatusImgNorth: "",

  sideFooterDirectionSouth: "South",
  sideFooterApronStatusSouth: "",
  sideFooterApronStatusImgSouth: "",

  sideinsectNetDirectionEast: "East",
  sideinsectNetApronStatusEast: "",
  sideinsectNetApronStatusImgEast: "",

  sideinsectNetDirectionWest: "West",
  sideinsectNetApronStatusWest: "",
  sideinsectNetApronStatusImgWest: "",

  sideinsectNetDirectionNorth: "North",
  sideinsectNetApronStatusNorth: "",
  sideinsectNetApronStatusImgNorth: "",

  sideinsectNetDirectionSouth: "South",
  sideinsectNetApronStatusSouth: "",
  sideinsectNetApronStatusImgSouth: "",

  sidePolyfieldDirectionEast: "East",
  sidePolyfieldApronStatusEast: "",
  sidePolyfieldApronImgEast: "",

  sidePolyfieldDirectionWest: "West",
  sidePolyfieldApronStatusWest: "",
  sidePolyfieldApronImgWest: "",

  sidePolyfieldDirectionNorth: "North",
  sidePolyfieldApronStatusNorth: "",
  sidePolyfieldApronImgNorth: "",

  sidePolyfieldDirectionSouth: "South",
  sidePolyfieldApronStatusSouth: "",
  sidePolyfieldApronImgSouth: "",

  secoundaryShadowNet: "",
  secoundaryShadowNetImg: "",
  docpolyfilmStatus: "",
  docpolyfilmImg: "",
  universalJoin: "",
  secoundaryShadenet: "",
  notes: "",
};

export const CreateCelebration = {
  name: "",
  description: "",
  time: "",
  duration: 3,
};

export const ReqForPayLineItemInfo = {
  particulars: "",
  id: "",
  hsn: "",
  itemUnit: "",
  itemQuantity: "",
  itemFrom: "inventory",
  // invoicenumber: "",
};
export const ReqForPayInfo = {
  paymentfor: "",
  invoicenumber: "",
  remainingPayment: "",
  invoiceImg: "",
  amount: "",
  vendor: "",
  paymentType: "",
  notes: "",
  poNum: "",
  paymentImg: "",
  accountholderName: "",
  bankName: "",
  accountNumber: "",
  ifcCode: "",
  siKitForClientId: "",
  siKitForClient: "",
  // grnNumber: "",
  uploadGRN: "",
  lineItems: [],
};

export const materialPlanning = {
  clientName: "",
  bay_size: "",
  span_size: "",
  hydrponicType: "",
  a_FramePercent: "",
  flatBedPercent: "",
  growBagPercent: "",
  dutchBucketPercent: "",
};

export const materialNewPlanning = {
  project: "",
  length: "",
  width: "",
  hydroponicType: "",
  a_FramePercent: "",
  flatBedPercent: "",
  growBagPercent: "",
  dutchBucketPercent: "",
  vehicalNum: "",
};

export const nhmApplicants = {
  satbaraDoc: "",
  utaraDoc: "",
  castDoc: "",
  certiDoc: "",
  studyDoc: "",
  tenDate: "",
  bankLoan: "",
  alterContactNo: "",
  Name: "",
  Mobile: "",
  Village: "",
  Taluka: "",
  District: "",
  Component: "",
  Structure: "",
  Area: "",
  System: "",
  TubularStructure: "",
  code: "",
  type: "",
  typeCode: "",
  size: "",
  areaSqM: "",
  subsidyPercent: "",
  maxSubsidyRs: "",
};

export const QuotationCeaInfo = {
  quotationDate: today.toISOString().substr(0, 10),
  costMarkupPercent: "",
  overrideUnitCost: "",
  bay_size: "",
  span_size: "",
  quotationType: "",
  a_FramePercent: "",
  flatBedPercent: "",
  growBagPercent: "",
  genrated_by: "",
  dutchBucketPercent: "",
  farmType: "outdoor",
  businessName: "",
  contactPersonName: "",
  phoneNumber: "",
  whatsAppNumber: "",
  contactPersonEmail: "",
  gstNumber: "",
  address: "",
  currencyCode: "INR",
  maxDiscount: "",
  showProjectFinancials: true,
  finalQuotation: false,
  notes: "",
  addOnParticulars: "",
  addOnParticularsPrice: "",
  isGrowSlab: false,
  fullyAutomatedSystem: false,
  dripSystem: false,
  foggerSystem: false,
  automation: false,
  weedMat: false,
  cropsupportSystem: false,
  aircirculationFan: false,
  // mechanicalGearedVentOpening: false,
  // growersCombo: false,
  // elect: false,
  // baseVarient: false,
  // midVarient: false,
  // topVarient: false,
};

export const ScrumLineItemInfo = {
  eid: "",
  scrumUpdate: "",
  present: false,
  absent: false,
};
export const ScrumSysInfo = {
  title: "",
  date: today.toISOString().substr(0, 10),
  conductMetting: "",
  depName: "",
  demoUpdates: "",
  lineItems: [],
};

export const FarmtranningInfoNew = {
  farmTrainingDate: "",
  farmTrainingFolder: "",
};
export const FarmTrainingMediaInfo = {
  trainingDate: "",
  uploadImage: [],
};

export const KitTrackingInfo = {
  orderDate: "",
  clientName: "",
  clientContactNumber: "",
  clientAddress: "",
  typeOfKit: "",
  courierServiceProvider: "",
  courierServiceProviderPersonName: "",
  courierServiceProviderPersonContactNumber: "",
  courierTrackingId: "",
  kitDispatchAddress: "",
  dispatchDate: "",
  kitPrice: "",
  courierServiceCharge: "",
  deliveryDate: "",
  generatedBy: "",
  note: "",
  kitStatus: "",
};

export const SocietyOnboardingInfo = {
  farmerId: 0,
  societyName: "",
  phone: "",
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  pincode: "",
  country: "",
  numofPeopleSize: 0,
};

export const NewLeadInfo = {
  preferred_language: "English",
  first_name: "",
  last_name: "",
  email: "",
  contact_number: "",
  whatsapp_number: "",
  enquiry_related_to: "",
  prior_knowledge_of_farming: "",
  interested_in: [],
  farm_construction_location: "",
  farm_construction_state: "",
  farm_land_type: "",
  total_area_available: "",
  facilities: [],
  tentative_start_time: "",
  looking_for_loan: false,
  notes: "",
  origin: "",
  lead_status: "",
  lead_alloted_to: "",
  customer_type: "",
  experience_level: "",
  occupation: "",
  location_type: "",
  land_available: "",
  funding_type: "",
  subsidy_interest: "",
  timeline: "",
  decision_stage: "",
  followUp: [],
};

export const podCastInfo = {
  podcastName: "",
  podcastType: "",
  podcastLanguage: "",
  podcastseriesName: "",
  guestName: "",
  guestCity: "",
  podcastDate: "",
  podcastVenue: "",
  cameraName: "",
  podcastvideoName: "",
  podcastDescription: "",
  podcastQuestions: "",
  podcastCredits: "",
  podcastEditor: "",
  podCastComingSoonPoster: "",
  podCastComingSoonDescription: "",
  podCastFinalFootage: "",
  markAsPublished: "",
  ispodcastComplated: false,
  rowImageGuest: "",
  podcastBrand: "",
  guestPrvRef: "",
  rawFolderPath: "",
  shootingDate: "",
  podcastFirstDraft: "",
  podCastPublishDescription: "",
  podCastPublishTitle: "",
  taskdedline: "",
};

export const reelsShortsInfo = {
  shortBrandingAss: "",
  shortTitle: "",
  shortScript: "",
  reelShortDate: "",
  shortThumbnail: "",
  shortDescription: "",
  shortDriveLink: "",
  reelShortEditor: "",
  markAsPublished: "",
  reelType: "",
  publishDate: "",
  reelFirstPath: "",
  publishTime: "",
  rawSource: "",
  taskdedline: "",
};

export const informativeVideoInfo = {
  videoBranding: "",
  videoTitle: "",
  videoScript: "",
  videoThumbnail: "",
  videoDescription: "",
  videoDriveLink: "",
  videoCredit: "",
  cameraName: "",
  markAsPublished: "",
  videoLanguage: "",
  videoVenue: "",
  shootingDate: "",
  rawFootagePath: "",
  videoEditor: "",
  commingSoonPoster: "",
  videofirstPath: "",
  taskdedline: "",
};

export const graphicsInfo = {
  postBranding: "",
  postHeadline: "",
  graphicsEditor: "",
  postSubheading: "",
  postCta: "",
  ctaSubheading: "",
  rawImage: null, // single file
  postTitle: "",
  postDescription: "",
  postType: "",
  platforms: [], // ✅ multi-select
  uploadImages: [], // ✅ multiple images
  markAsPublished: [], // ✅ multiple proofs (optional)
  taskdedline: "",
};

export const guestInfo = {
  guestName: "",
  guestDescription: "",
  guestPodcast: "",
  guestContactNum: "",
  guestEmailId: "",
  guestInstaProfile: "",
  guestIntrested: "",
  guestBusinessName: "",
};

export const conceptInfo = {
  brandingAsset: "",
  heading: "",
  subHeading: "",
  reference: "",
  ctaText: "",
  subCtaText: "",
};

export const courceInfo = {
  courceName: "",
  topicName: "",
  topicScript: "",
  assignedTo: "",
  courceUrl1: "",
  courceUrl2: "",
  markaspublished: false,
  taskdedline: "",
};

export const courceNewInfo = {
  courseName: "",
  courseDes: "",
  courseUrl1: "",
  courseUrl2: "",
};
export const postingScheduleInfo = {
  id: "",
  topic: "",
  description: "",
  filepath: "",
};
export const createVendorBuyOrderInfo = {
  vendorName: "",
  vendorAddress: "",
  vendorState: "",
  pincode: "",
  contactNumber: "",
  cropName: "",
  vendorOfferPricePerKg: "",
  vendorRequirement: "",
  requirementDeadline: "",
  repativeOrder: false,
  vendorRequirementUnit: "Kg",
  customDeadlineDate: "",
};

export const templateDeatilsInfo = {
  templateName: "",
  templateLabel: "",
  templateHitCondtion: "",
  isActive: true,
  description: "",
};

export const socialMediaPlanInfo = {
  pageName: "",
  format: "",
  startDate: "",
  endDate: "",
  days: [],
  time: "",
  platforms: [],
  scheduleName: "",
  contentType: "",
};

export const CandidateDetailsInfo = {
  Fname: "",
  // Lname: "",
  email: "",
  interviewType: "",
  Schedulelink: "",
  position: "",
  phoneNo: "",
  jobType: "",
  Etype: "",
  uploadcv: "",
  departments: "",
  skills: "",
  recruterRemark: "",
  IsQulified: false,
  genratedBy: "",
  assignedInterviewer: "",
  interviewScheduleDate: "",
  followUp: [],
};

export const RFMINFOlineItemInfo = {
  particulars: "",
  itemUnit: "",
  itemQuantity: "",
};

export const RequestForMaterial = {
  project: "",
  purposeUse: "",
  itemFrom: "inventory",
  notes: "",
  lineItems: [],
};

export const MediaTaskAssign = {
  taskName: "",
  taskDescription: "",
  brandAsset: "",
  agencyId: "",
  agencyName: "",

  rawImages: [],
  rawVideos: [],

  submittedWork: [],
  submittedWorkDelete: [],

  links: [
    {
      title: "",
      url: "",
    },
  ],

  instructions: "",
  deadline: "",
};
